import React from "react";

import { ReactComponent as LoadingSpinner } from "../../assets/loading.svg";
import { LoadContainer } from "./styles";

const Loading = () => {
	return (
		<LoadContainer>
			<LoadingSpinner />
		</LoadContainer>
	);
};

export { Loading };
